import React, { FC } from "react";
import { Stack, SxProps } from "@mui/material";
import { useTheme, Theme } from "@mui/material/styles";
interface IHomeSegmentCardProps {
  children: any;
  sx?: SxProps;
}

const CONTAINER_STYLES = (theme: Theme) => ({
  height: "450px",
  borderRadius: "4px",
  backgroundColor: theme.custom.white,
  boxShadow:
    "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)",
  backdropFilter: "blur(40px)", // Add background blur
  WebkitBackdropFilter: "blur(40px)", // For Safari compatibility
  transition: `box-shadow 0.15s ${theme.custom.timingFunction1}`,
  overflow: "hidden",
  ":hover": {
    boxShadow: `0 0 0 3px ${theme.custom.homeCardBoldGray}`
  }
});

const HomeSegmentCard: FC<IHomeSegmentCardProps> = (props) => {
  const { children, sx } = props;
  const theme = useTheme();

  return <Stack sx={{ ...CONTAINER_STYLES(theme), ...sx }}>{children}</Stack>;
};

HomeSegmentCard.defaultProps = {
  sx: {}
};

export default HomeSegmentCard;
